/** A partir de este largo la reseña se muestra recortada en el carrusel. */
export const LARGO_MAXIMO = 340;
/** Posición máxima del corte (se corta en la última palabra antes de este carácter). */
export const CORTE = 320;

/**
 * Texto completo de la reseña, con saltos de párrafo reales.
 * @param {import('../data/viajes').Resena} resena
 * @returns {string}
 */
export const textoResena = (resena) => resena.texto.replace(/\\n/g, '\n').trim();

/**
 * @typedef {Object} ResumenResena
 * @property {string} completo  texto completo
 * @property {string} corto     texto recortado con "…" (igual a completo si no es largo)
 * @property {boolean} largo    true si pasa de LARGO_MAXIMO y necesita "Leer completa"
 */

/**
 * Versión para el carrusel "Mis viajeros".
 * @param {import('../data/viajes').Resena} resena
 * @returns {ResumenResena}
 */
export function resumenResena(resena) {
  const completo = textoResena(resena);
  const largo = completo.length > LARGO_MAXIMO;
  const corto = largo ? `${completo.slice(0, completo.lastIndexOf(' ', CORTE)).replace(/[,.;:!¡]+$/, '')}…` : completo;
  return { completo, corto, largo };
}

/**
 * Destinos de la reseña en una sola línea: "Disney World, Orlando · Universal Florida Resort".
 * @param {import('../data/viajes').Resena} resena
 * @returns {string}
 */
export const destinoEnLinea = (resena) => resena.destino.replace(/\n/g, ' · ');

/**
 * Punto de la foto que queda a la vista en sus recortes (polaroid, miniaturas, pines y avatares), como valor de CSS
 * object-position. Sin encuadre en los datos, el centro.
 * @param {import('../data/viajes').Resena} resena
 * @returns {string}
 */
export const encuadreDe = (resena) => resena.encuadre || '50% 50%';

/**
 * Etiqueta corta para las miniaturas: "Familia Sánchez" → "Sánchez".
 * @param {import('../data/viajes').Resena} resena
 * @returns {string}
 */
export const nombreCorto = (resena) => resena.nombre.replace('Familia ', '');
